var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#0086ff;}.cls-4{fill:#45a7ff;}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "binancecoin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-3",
    width: 30,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    className: "cls-4",
    d: "M0,7A7,7,0,0,1,7,0h6.66a16.54,16.54,0,0,1,.82,5.17A16.55,16.55,0,0,1,0,21.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.15,20.61V20s0-.06-.06-.07a5.34,5.34,0,0,1-1-.26,2.92,2.92,0,0,1-1.61-1.42,3.17,3.17,0,0,1-.31-1,.4.4,0,0,1,.42-.46h.92a.41.41,0,0,1,.41.34,2.18,2.18,0,0,0,.22.62,1.5,1.5,0,0,0,.89.69,3.52,3.52,0,0,0,.79.13,2.8,2.8,0,0,0,.87-.09,1.64,1.64,0,0,0,1-.71,1.49,1.49,0,0,0,.17-.9,1,1,0,0,0-.38-.73,1.83,1.83,0,0,0-.5-.26,5.76,5.76,0,0,0-1.24-.3A7.8,7.8,0,0,1,13,15.17a3,3,0,0,1-1-.57,2.15,2.15,0,0,1-.63-1.22,3.34,3.34,0,0,1,0-.83,2.46,2.46,0,0,1,.86-1.76A3.29,3.29,0,0,1,13.87,10L14,10c.06,0,.08,0,.08-.09V8.74a.5.5,0,0,1,.37-.48h.87a.5.5,0,0,1,.51.51V9.93c0,.1,0,.1.1.12a2.82,2.82,0,0,1,1.3.51,2.77,2.77,0,0,1,1.09,1.71.39.39,0,0,1-.3.5h-1a.42.42,0,0,1-.43-.3,1.91,1.91,0,0,0-.28-.55,1.41,1.41,0,0,0-.86-.52,3.29,3.29,0,0,0-.94-.06,2.31,2.31,0,0,0-.68.15,1.1,1.1,0,0,0-.7.92,1.46,1.46,0,0,0,.05.66,1,1,0,0,0,.62.64,3.36,3.36,0,0,0,.94.26c.53.09,1.06.14,1.58.27a4,4,0,0,1,1.33.55,2.13,2.13,0,0,1,.9,1.38,3.67,3.67,0,0,1,.07,1,2.8,2.8,0,0,1-1,2,3.61,3.61,0,0,1-1.65.75c-.1,0-.1,0-.1.12v1.17a.49.49,0,0,1-.51.51h-.74a.49.49,0,0,1-.41-.21.38.38,0,0,1-.09-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.07,15c0,.33,0,.66-.06,1a10,10,0,0,1-2.27,5.43A9.66,9.66,0,0,1,20,23.72a9.56,9.56,0,0,1-1.91.84l-.18.07a.37.37,0,0,1-.41-.23.59.59,0,0,1-.05-.22V23.4a.57.57,0,0,1,.41-.58,8.3,8.3,0,0,0,2.51-1.49,7.86,7.86,0,0,0,1.93-2.43,8.82,8.82,0,0,0,.84-2.44,7.25,7.25,0,0,0,.09-.8,8.69,8.69,0,0,0,0-1A8.55,8.55,0,0,0,23,12.7a8.24,8.24,0,0,0-1.69-3.1,7.89,7.89,0,0,0-2.65-2,5.74,5.74,0,0,0-.72-.3.8.8,0,0,1-.43-.62V5.82c0-.17.15-.44.34-.44a.32.32,0,0,1,.17,0A10.24,10.24,0,0,1,21,7a10.1,10.1,0,0,1,3.8,6A10.61,10.61,0,0,1,25,14.13C25,14.43,25.05,14.74,25.07,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M4.93,14.93c0-.3,0-.63.06-.95A10.07,10.07,0,0,1,7.25,8.55a10,10,0,0,1,3.06-2.46,10.73,10.73,0,0,1,1.56-.66l.18-.06a.36.36,0,0,1,.41.23.57.57,0,0,1,0,.22c0,.26,0,.52,0,.79a.59.59,0,0,1-.41.58A8.08,8.08,0,0,0,9.59,8.67,7.86,7.86,0,0,0,7.66,11.1a8.44,8.44,0,0,0-.8,2.24,8,8,0,0,0-.13,1,8.86,8.86,0,0,0,0,1,8.22,8.22,0,0,0,.35,2,8.46,8.46,0,0,0,1.37,2.67,8.19,8.19,0,0,0,2.63,2.23,9.88,9.88,0,0,0,1,.47.68.68,0,0,1,.41.59v.76a.59.59,0,0,1-.16.37.32.32,0,0,1-.36.07,11.4,11.4,0,0,1-1.66-.69A10.08,10.08,0,0,1,6,19.36a9.53,9.53,0,0,1-.84-2.53A8.37,8.37,0,0,1,5,15.71C5,15.46,5,15.21,4.93,14.93Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdCoin);
export default __webpack_public_path__ + "static/media/usd-coin.7da9330bc787be8e26be6928fd06a22c.svg";
export { ForwardRef as ReactComponent };